<template>
  <div class="contranter">
    <Topbar :tab_index="tab_index" :had_login="had_login"></Topbar>
    <div class="box-c" v-if="all_imgs.length <= 0">
      <div class="com-bx">
        <div class="log-out" @click="logoOut">退出登录</div>
        <img src="../assets/login-icon.png" class="co-hea" />
        <div class="co-name">
          <div class="co-a">{{ u_info.user_name }}</div>
          <div class="co-b">
            <img src="../assets/add-icon.png" class="co-add" />
            {{ u_info.user_province }} {{ u_info.user_city }}
          </div>
        </div>
        <div class="co-txt">
          <div class="co-rt">大赛进度：</div>
          <div class="co-rx">
            <div class="co-rg" v-for="(item, i) in list" :key="i">
              <span :class="i < list.length - 1 ? 'co-d' : 'co-d co-d-last'">
                {{ item.msg }}
              </span>
              <span v-if="i < list.length - 1">></span>
            </div>
            <!-- <div class="co-rg">
              <span>></span>
              <span class="co-d">已结束</span>
            </div> -->
          </div>
        </div>
      </div>
      <div class="com-bx-l">
        <div class="co-ls-tit tabs">
          <div :class="{ 'tab-1': true, active: tab == 1 }" @click="swithTab(1)">
            <span class="txt">我的作品</span>
          </div>
          <div :class="{ 'tab-2': true, active: tab == 2 }" @click="swithTab(2)">
            <span class="txt">往期作品</span>
          </div>
        </div>
        <div class="co-ls" v-for="(item, i) in works_list" :key="i" :class="(i + 1) % 3 == 0 ? 'co-ls-s' : ''">
          <div class="col-tit">作品名称：{{ item.works_title }}</div>
          <div class="col-txt-tt">作品描述：</div>
          <div class="col-txt" :class="item.open_o == 2 ? '' : 'col-txt-ov'">
            {{ item.works_detail }}
          </div>
          <img class="col-do-icon" @click="slideToBoxUp(i)" v-if="item.open_o == 1" src="../assets/down-icon.png" />
          <img class="col-do-icon" @click="slideToBoxDown(i)" v-if="item.open_o == 2" src="../assets/up-icon.png" />
          <div class="col-ibox swiper-container" :class="'swiper-container-' + i" @click="checkAll(i)">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(it, i) in item.works_pics" :key="i">
                <img class="banner-img" :src="it" />
              </div>
            </div>
            <img class="col-img" :src="item.works_pics[0]" />
          </div>
          <div class="col-doxp" :class="'swiper-pagination-' + i"></div>
          <div class="col-ffps">
            <div class="del-btn" @click="deleteWorks(item.activity_id, i)">
              删除
            </div>
            <a :href="item.works_file" target="_blank"><img class="ls-pdf" src="../assets/pdf-icon.png"/></a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="all_imgs.length > 0" class="back-all">
      <img class="ik-al" v-for="(item, i) in all_imgs" :key="i" :src="item" />
      <img class="close-img" @click="closeExample" src="../assets/close-btn.png" />
    </div>
  </div>
</template>

<script>
import api from "../api/api";
import ops from "../leo.wang.util/operator.string";
import Topbar from "../components/Topbar.vue";
import pub from "../common/pub.js";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import $ from "jquery";
export default {
  name: "Dashboard",
  components: {
    Topbar: Topbar,
  },
  data() {
    return {
      title: "",
      tab_index: 3,
      had_login: false,
      u_info: {},
      list: [],
      works_list: [],
      all_works_data: [],
      all_imgs: [],
      swi_handl: null,
      tab: 1,
    };
  },
  methods: {
    closeExample() {
      this.all_imgs = [];
    },
    checkAll(index) {
      this.all_imgs = this.works_list[index].works_pics;
    },
    slideToBoxUp(index) {
      this.works_list[index].open_o = 2;
      this.$forceUpdate();
      console.log(this.works_list[index].open_o);
      console.log(this.works_list);
    },
    slideToBoxDown(index) {
      this.works_list[index].open_o = 1;
      this.$forceUpdate();
      console.log(this.works_list[index].open_o);
      console.log(this.works_list);
    },
    logoOut() {
      localStorage.removeItem("mobile");
      this.$router.push("/");
    },
    deleteWorks(id, index) {
      let that = this;
      api
        .delWorks({
          activity_id: ops.encode(id),
          user_phone: ops.encode(that.u_info.user_phone),
        })
        .then((res) => {
          if (res.data.code == 200) {
            that.works_list.splice(index, 1);
          }
          pub.msgTip("删除成功");
        });
    },
    naviToDetail(item) {
      // this.$router.push()
    },
    loadData() {
      let that = this;
      let phone_number = localStorage.getItem("mobile");
      if (phone_number) {
        this.had_login = true;
        api
          .getMyInfo({
            user_phone: ops.encode(phone_number),
          })
          .then((res) => {
            that.u_info = res.data.data.info;
            that.list = res.data.data.progress;
            that.all_works_data = res.data.data.works_list;
            that.filterWorksByTab(that.tab);
          });
      }
    },
    swithTab(tab) {
      if (this.tab != tab) {
        this.tab = tab;
        this.filterWorksByTab(tab);
      }
    },
    filterWorksByTab(tab) {
      let that = this;
      let currentYear = 2026;

      if (tab == 1) {
        that.works_list = that.all_works_data.filter((work) => work.year_col == currentYear.toString());
      } else {
        that.works_list = that.all_works_data.filter((work) => work.year_col != currentYear.toString());
      }

      that.works_list.forEach((element) => {
        element.works_pics = element.works_pics.split(";");
        element["open_o"] = 1;
      });

      that.$nextTick(() => {
        console.log("afasdf");
        setTimeout(function() {
          var i = 0;
          that.works_list.forEach((element) => {
            console.log("----");
            element["act_index"] = 0;
            new Swiper(".swiper-container-" + i, {
              loop: true,
              speed: 1000,
              autoplay: {
                delay: 2000,
                disableOnInteraction: false,
              },
              observer: true,
              observeParents: true,
              pagination: {
                el: ".swiper-pagination-" + i,
                clickable: true,
              },
            });
            i++;
          });
        }, 300);
      });
      console.log(that.works_list);
    },
  },
  created() {
    //window.document.title = this.title;
    this.loadData();
  },
  mounted() {
    let that = this;
  },
};
</script>

<style scoped>
.box-c {
  background: #bebde4;
  overflow: hidden;
  min-height: 10.8rem;
}

.com-bx {
  position: relative;
  padding: 0.73rem 0rem 0.52rem;
  width: 15rem;
  margin: 0 auto;
  overflow: hidden;
}

.log-out {
  position: absolute;
  width: 1.4rem;
  height: 0.4rem;
  right: 0rem;
  top: 0.28rem;
  line-height: 0.4rem;
  font-size: 0.18rem;
  color: rgba(0, 0, 0, 1);
  text-align: center;
  border: 0.01rem solid rgba(0, 0, 0, 1);
  cursor: pointer;
}

.com-bx-l {
  padding: 0rem 0rem 0.52rem;
  width: 15rem;
  margin: 0 auto;
  overflow: hidden;
}

.co-hea {
  float: left;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 1.5rem;
}

.co-name {
  font-size: 0.32rem;
  float: left;
  margin-left: 0.26rem;
  margin-top: 0.31rem;
}

.co-b {
  font-size: 0.24rem;
  margin-top: 0.21rem;
  line-height: 0.24rem;
}

.co-add {
  float: left;
  margin-right: 0.1rem;
  width: 0.2rem;
}

.co-txt {
  float: right;
  margin-top: 0.38rem;
}

.co-rx {
  margin-top: 0.17rem;
  overflow: hidden;
  margin-left: -0.2rem;
}

.co-rx span {
  font-size: 0.16rem;
}

.co-d {
  display: inline-block;
  padding: 0rem 0.1rem;
  border-radius: 2.17rem;
  border: 0.01rem solid rgba(0, 0, 0, 1);
  margin: 0 0.2rem;
}

.co-d-last {
  background: rgba(0, 0, 0, 1);
  color: #fff;
}

.co-rg {
  float: left;
  line-height: 0.22rem;
}

.co-rg span {
  float: left;
}

.co-ls-tit {
  font-size: 0.34rem;
  border-bottom: 0.01rem solid #000000;
}

.co-ls {
  position: relative;
  width: 4.34rem;
  overflow: hidden;
  margin-top: 0.53rem;
  float: left;
  margin-right: 0.99rem;
}

.col-tit {
  font-size: 0.22rem;
}

.col-txt-tt {
  font-size: 0.22rem;
  margin: 0.2rem 0rem 0.07rem;
}

.col-txt {
  font-size: 0.18rem;
  overflow: hidden;
  height: auto;
}

.col-txt-ov {
  /* height: 1rem; */
  text-overflow: -o-ellipsis-lastline;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  overflow: hidden;
  -webkit-box-orient: vertical;
}

.col-img {
  width: 100%;
  display: block;
}

.col-ibox {
  height: 2.45rem;
  overflow: hidden;
  margin-top: 0.24rem;
  margin-bottom: 0rem;
}

.del-btn {
  width: 1.4rem;
  height: 0.4rem;
  border: 0.01rem solid rgba(0, 0, 0, 1);
  text-align: center;
  font-size: 0.18rem;
  line-height: 0.4rem;
  cursor: pointer;
  float: left;
}

.co-ls-s {
  margin-right: 0rem;
}

.co-rt {
  font-size: 0.22rem;
}

.col-do-icon {
  cursor: pointer;
  width: 0.2rem;
  display: block;
  margin: 0.1rem auto 0rem;
}

.col-ffps {
  overflow: hidden;
}

.ls-pdf {
  float: right;
  width: 0.45rem;
}

.banner-img {
  width: 4.34rem;
}

.back-all {
  background: #000;
  padding: 1rem 0rem;
}

.ik-al {
  display: block;
  width: 10rem;
  margin: 0 auto;
}

.close-img {
  position: absolute;
  z-index: 1111;
  top: 1.5rem;
  right: 0.5rem;
  width: 0.31rem;
}

.col-doxp {
  text-align: center;
  /* height: 0.1rem; */
  line-height: 0rem;
  margin-bottom: 0.45rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/Center.vue